import { type AxiosInstance } from 'axios';
import { createAxiosInstance } from '@/dataProvider/axios';
import { env } from '@/config/env';

export const RAG_SERVICE_BASE_URL = `${env.API_URL}/proxy/utilities`;
export const RAG_SERVICE_JOBS_BASE_URL = `${env.API_URL}/proxy/rag-service`;

export const ragServiceAxios: AxiosInstance = createAxiosInstance(RAG_SERVICE_BASE_URL) as AxiosInstance;
export const ragServiceJobsAxios: AxiosInstance = createAxiosInstance(RAG_SERVICE_JOBS_BASE_URL) as AxiosInstance;

ragServiceJobsAxios.interceptors.response.use(
  (response) => {
    if (response.data && typeof response.data === 'object' && 'data' in response.data) {
      if (response.data.status === 'error') {
        return Promise.reject(new Error(response.data.message || 'Request failed'));
      }
      return { ...response, data: response.data.data };
    }
    return response;
  },
  (error) => Promise.reject(error)
);

ragServiceAxios.interceptors.response.use(
  (response) => {
    if (response.data && typeof response.data === 'object' && 'data' in response.data) {
      if (response.data.status === 'error') {
        return Promise.reject(new Error(response.data.message || 'Request failed'));
      }
      return { ...response, data: response.data.data };
    }
    return response;
  },
  (error) => Promise.reject(error)
);
